import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Chase ID for linking chase moves.
 *
 * @remarks
 * System-managed UUID that links chase moves together. Vehicles in the same chase
 * group share this ID. Used for:
 * - Ridegroup management
 * - Cost allocation
 * - Status synchronization across related moves
 */
export const schema = z.string().uuid().optional();

export type ChaseId = z.infer<typeof schema>;

export const definition = define({
  key: 'chase_id',
  schema,
  label: 'Chase ID',
  description:
    'UUID linking chase moves together for ridegroup management, cost allocation, and status sync. Set by shuttle/chase planning, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
